import { Box, Typography, useTheme, Grid,Menu,Avatar,Divider,MenuItem,Stack,Link,IconButton } from '@mui/material';
import Cookies from 'js-cookie';
import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'react-use';
import './App.css';
import { getUserId, USERID,convertArrayToDictionary } from './common/utils';
import Login from './components/login';
import Welcome from './components/welcome';
import { authenticateToken, loginSelector } from "./store/slices/login";
import ThemeProvider from './theme';
import AppConfig from './appConfig';
import { uploadSelector } from "./store/slices/upload";
import LoadingIndicator from './components/loadingindicator';

function App() {
  const dispatch = useDispatch();
  const [isAuthenticated, setAuthenticate] = useState(0);
  const { validOtp, isvalidToken } = useSelector(loginSelector);
  const { users, isFileLoader } = useSelector(uploadSelector);
  const theme = useTheme()

  useEffectOnce(() => {

    if (!_.isEmpty(Cookies.get('customAuthToken'))) {
      dispatch(authenticateToken(Cookies.get('customAuthToken')))
    }
    else {
      setAuthenticate(1)
    }
  })
  useEffect(() => {
    if (!localStorage.getItem(USERID) && !_.isEmpty(Cookies.get('customAuthToken'))) {
      localStorage.setItem(USERID, Cookies.get(USERID))
    }
  }, [Cookies.get(USERID)])

  useEffect(() => {
    if (isvalidToken) {
      setAuthenticate(2)
    }
    else {
      setAuthenticate(1)
    }
  }, [isvalidToken])

  useEffect(() => {
    if (validOtp == 1) {
      setAuthenticate(2);
    }
  }, [validOtp])
  const userId = useMemo(() => getUserId(), [localStorage.getItem(USERID), isAuthenticated])
  const usersDic = React.useMemo(() => convertArrayToDictionary(users, 'CustomUserId'), [users]);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };
    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    const renderMenu = (
        <Menu
            sx={{
                mt: '45px',
                '& .MuiPaper-root': {
                    border: '1px solid rgb(219 224 229 / 65%);',
                    padding: '10px 10px 0'
                },

            }}
            id="menu-appbar"
            anchorEl={anchorElUser}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={Boolean(anchorElUser)}
            onClose={handleCloseUserMenu}
        >
            <Grid container justifyContent="space-between" alignItems="center">
                <Grid item>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Avatar alt={"userName"} src={""} />
                        <Stack>
                            <Typography variant="subtitle1" sx={{ marginLeft: "4px" }}>{usersDic[userId]?usersDic[userId]?.Email.split("@")[0]:""}</Typography>
                            <Typography varianty='caption' color='secondary' sx={{ marginLeft: "4px" }}>{usersDic[userId]?.Email}</Typography>
                        </Stack>
                    </Stack>
                </Grid>

            </Grid>
            <Divider sx={{ my: theme => theme.spacing(1) }} />
            <MenuItem >
                <Link href={"/"} style={{ textDecoration: 'none' }} onClick={()=>{localStorage.removeItem(USERID);Cookies.remove('customAuthToken');Cookies.remove(USERID)}}>
                    {"Logout"}
                </Link >
            </MenuItem>

        </Menu>

    );
  
  return (
    <ThemeProvider>
      <Box id='mainAppIndex' sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', position: 'relative' }}>
        {isAuthenticated === 1 &&
          <Login />
        }
        {(isAuthenticated === 2 && userId) &&
          <>
            <Box
              sx={{
                width: "100%",
                position: "sticky",
                top: 0,
                left: 0,
                zIndex: 51,
              }}
            >
              <Box
                aria-label="nav-header"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  height: "70px",
                  flexGrow: 1,
                  pr: (theme) => theme.spacing(2),
                  pl: (theme) => theme.spacing(2),
                  borderBottom: "none",
                  alignContent: "center",
                  zIndex: 1000,
                  boxShadow: "0px 8px 24px rgba(19,25,32,0.08)",
                  backdropFilter: "blur(8px)",
                  background: '#021931',
                  color: "#fff",
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: 'calc(100vw - 32px)', position: 'absolute', alignItems: 'flex-start' }}>
                  <div style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}>
                    <a href={AppConfig.baseUrl} id="link">
                      {/* <h5> */}
                      <img src={'https://static.hearscore360.net/images/hearScore.png'} alt="Logo" />
                      {/* <span style={{ color: '#fff', fontWeight: '600', fontFamily: 'Inter, sans-serif' }}>Upload Portal</span> */}
                      {/* </h5> */}
                    </a>
                    <h4 className="MuiTypography-root MuiTypography-h5 MuiTypography-noWrap" style={{ color: '#fff', fontWeight: '600', fontFamily: 'Inter, sans-serif' }}>Upload Portal</h4>

                  </div>
                  <Box sx={{ flexGrow: 0, display: 'flex', gap: '16px', alignItems: 'center',mt:'10px' }}>
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0, pr: '12px' }} size="large"
                        edge="end"
                        aria-label="account of current user"
                        aria-controls={'primary-search-account-menu'}
                        color="primary"
                    >
                        <Avatar alt={""} src={""} />
                        {/* <Avatar alt={"sarora"} src={""} /> */}
                    </IconButton>

                    {renderMenu}
                    </Box>
                </Box>
              </Box>
            </Box>
            <Welcome/>
            <div style={{position: 'absolute',top: '6.5%',left: '38%', width:'700px'}}>  
              <LoadingIndicator isFileLoader={isFileLoader}/>
            </div>
          </>
        }
      </Box>
    </ThemeProvider >
  );
}

export default App;
